export default __webpack_public_path__ + "static/media/CNo.56-2.4825c2ce.jpg";